import { BaseError, createErrorBuilder, } from '@wix/public-editor-platform-errors';
export var ApplicationsErrorCode;
(function (ApplicationsErrorCode) {
    ApplicationsErrorCode["ApplicationDoesNotExist"] = "ApplicationDoesNotExist";
    ApplicationsErrorCode["ApplicationIsNotReady"] = "ApplicationIsNotReady";
    ApplicationsErrorCode["ForbiddenPrivateApiCall"] = "ForbiddenPrivateApiCall";
})(ApplicationsErrorCode || (ApplicationsErrorCode = {}));
class ApplicationsError extends BaseError {
    constructor(message, code) {
        super(message, code, 'Applications Private API Error');
    }
    withApplicationId(appDefinitionId) {
        this.state.appDefinitionId = appDefinitionId;
        return this;
    }
    withMethod(method) {
        this.state.method = method;
        return this;
    }
    withEnv(env) {
        this.state.env = env;
        return this;
    }
    withAppType(appType) {
        this.state.appType = appType;
        return this;
    }
}
export const createApplicationsError = createErrorBuilder(ApplicationsError);
//# sourceMappingURL=ApplicationsError.js.map